var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 233,
    viewBox: "0 0 234 233",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_209_460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6472 54.8064C33.6472 47.8686 36.4033 41.2149 41.3091 36.3091C46.2149 31.4033 52.8686 28.6472 59.8064 28.6472H71.697C78.6042 28.6433 85.2295 25.9077 90.1273 21.0373L98.4507 12.7139C100.882 10.2692 103.772 8.32917 106.955 7.00534C110.139 5.68151 113.552 5 117 5C120.448 5 123.861 5.68151 127.045 7.00534C130.228 8.32917 133.118 10.2692 135.549 12.7139L143.873 21.0373C148.772 25.9124 155.406 28.6472 162.303 28.6472H174.194C181.131 28.6472 187.785 31.4033 192.691 36.3091C197.597 41.2149 200.353 47.8686 200.353 54.8064V66.697C200.353 73.5935 203.088 80.2284 207.963 85.1273L216.286 93.4507C218.731 95.8817 220.671 98.772 221.995 101.955C223.318 105.139 224 108.552 224 112C224 115.448 223.318 118.861 221.995 122.045C220.671 125.228 218.731 128.118 216.286 130.549L207.963 138.873C203.092 143.77 200.357 150.396 200.353 157.303V169.194C200.353 176.131 197.597 182.785 192.691 187.691C187.785 192.597 181.131 195.353 174.194 195.353H162.303C155.396 195.357 148.77 198.092 143.873 202.963L135.549 211.286C133.118 213.731 130.228 215.671 127.045 216.995C123.861 218.318 120.448 219 117 219C113.552 219 110.139 218.318 106.955 216.995C103.772 215.671 100.882 213.731 98.4507 211.286L90.1273 202.963C85.2295 198.092 78.6042 195.357 71.697 195.353H59.8064C52.8686 195.353 46.2149 192.597 41.3091 187.691C36.4033 182.785 33.6472 176.131 33.6472 169.194V157.303C33.6433 150.396 30.9077 143.77 26.0373 138.873L17.7139 130.549C15.2692 128.118 13.3292 125.228 12.0053 122.045C10.6815 118.861 10 115.448 10 112C10 108.552 10.6815 105.139 12.0053 101.955C13.3292 98.772 15.2692 95.8817 17.7139 93.4507L26.0373 85.1273C30.9077 80.2295 33.6433 73.6042 33.6472 66.697V54.8064Z",
    fill: "#FFC50B",
    stroke: "white",
    strokeWidth: 8.91174,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.074 104.368C133.002 105.232 133.866 105.936 134.666 106.48C135.466 106.992 136.218 107.376 136.922 107.632C137.658 107.888 138.346 108.016 138.986 108.016C139.818 108.016 140.458 107.84 140.906 107.488C141.354 107.104 141.578 106.592 141.578 105.952C141.578 105.376 141.386 104.896 141.002 104.512C140.65 104.096 140.122 103.728 139.418 103.408C138.714 103.088 137.818 102.752 136.73 102.4C135.706 102.016 134.714 101.568 133.754 101.056C132.794 100.512 131.994 99.808 131.354 98.944C130.746 98.048 130.442 96.912 130.442 95.536C130.442 94.224 130.794 93.12 131.498 92.224C132.202 91.296 133.146 90.608 134.33 90.16C135.546 89.68 136.89 89.44 138.362 89.44C139.61 89.44 140.778 89.6 141.866 89.92C142.954 90.24 143.962 90.672 144.89 91.216C145.818 91.728 146.634 92.336 147.338 93.04L144.602 96.88C143.802 96.016 142.842 95.312 141.722 94.768C140.634 94.224 139.562 93.952 138.506 93.952C137.802 93.952 137.242 94.096 136.826 94.384C136.442 94.64 136.25 95.04 136.25 95.584C136.25 96.064 136.442 96.496 136.826 96.88C137.242 97.232 137.818 97.552 138.554 97.84C139.322 98.128 140.186 98.48 141.146 98.896C142.33 99.344 143.418 99.856 144.41 100.432C145.434 100.976 146.25 101.664 146.858 102.496C147.466 103.328 147.77 104.416 147.77 105.76C147.77 107.968 147.05 109.696 145.61 110.944C144.17 112.16 142.186 112.768 139.658 112.768C138.09 112.768 136.65 112.56 135.338 112.144C134.058 111.728 132.89 111.184 131.834 110.512C130.81 109.808 129.882 109.056 129.05 108.256L132.074 104.368ZM149.232 89.92H162.864V95.152H149.232V89.92ZM153.024 82.24H159.024V112H153.024V82.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7855 93.38V81.77L118.416 75.92V140H105.906V89.42L90.7855 93.38Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_209_460",
    x: 0.891771,
    y: 0.544189,
    width: 232.216,
    height: 232.216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.65217
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.32609
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_209_460"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_209_460",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.75c9c9a734d03a31cdac1a2cef699219.svg";
export { ForwardRef as ReactComponent };